/**
 * https://www.pdftron.com/api/web/Core.AnnotationManager.html#getReadOnly__anchor
 */
export default () => window.documentViewer.getAnnotationManager().isReadOnlyModeEnabled();
